import moment from 'moment'
import dateUtils from './date-helper'
import GAME_STATUS from '../enums/gameStatus'

export function mapGameForDisplay(game) {
  const noTimezoneFormat = 'YYYY-MM-DDTHH:mm'
  return {
    accessType: game.accessType,
    gameLogo: game.gameLogo,
    gameName: game.gameName,
    autoStop: game.autoStop,
    gameDisplayedName: game.gameDisplayedName,
    gameDescription: game.gameDescription,
    geo: {
      lat: game.gameLatitude,
      lng: game.gameLongitude,
      zoom: game.gameZoom,
    },
    createdAt: game.createdAt,
    questionRadius: game.questionRadius,
    startTime: moment(game.gameStartDate, noTimezoneFormat).toDate(),
    startDate: moment(game.gameStartDate, noTimezoneFormat).toDate(),
    endTime: moment(game.gameEndDate, noTimezoneFormat).toDate(),
    endDate: moment(game.gameEndDate, noTimezoneFormat).toDate()
  }
}

export function createFormattedElapsedTime(gameTimer) {
  const hoursElapsed = gameTimer.hoursElapsed
  const minutesElapsed = gameTimer.minutesElapsed
  return `${('0' + hoursElapsed).slice(-2)}:${('0' + minutesElapsed).slice(-2)}`
}

export function isGameStopped(game) {
  return game.gameStatus === GAME_STATUS.STOPPED
}

export function isGamePlaying(game) {
  return game.gameStatus === GAME_STATUS.PLAYING
}

export function isGamePaused(game) {
  return game.gameStatus === GAME_STATUS.PAUSED
}

export function isGameNew(game) {
  return game.gameStatus === GAME_STATUS.NEW
}

export function isGameNotActive(game) {
  return isGameNew(game) || isGameStopped(game)
}

export function isGameNotSetUp(game) {
  return game.questionCount === 0 ||
    (game.accessType === 'private' && game.teamCount === 0 && game.playerCanAddTeams === false)
}

export function isGameCloned(game) {
  return !!game.groupId
}

export function formatGames(games) {
  return games.map((game) => {
    game.gameStartRawDate = game.gameStartDate
    game.gameEndRawDate = game.gameEndDate
    game.gameEndDate = dateUtils.formatGameDate(game.gameEndDate)
    game.gameStartDate = dateUtils.formatGameDate(game.gameStartDate)
    game.timer = {
      minutesElapsed: 0,
      hoursElapsed: 0,
    }
    return game
  })
}

export function stop(game) {
  game.gameStatus = GAME_STATUS.STOPPED
}

export default {
  mapGameForDisplay,
  createFormattedElapsedTime,
  formatGames,
  isGameNew,
  isGamePlaying,
  isGamePaused,
  isGameStopped,
  isGameNotActive,
  isGameNotSetUp,
  isGameCloned,
  stop,
}

